import React, { useState } from "react";
import { Modal, Table, Button } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ScoreInterpretationTable.css"; // Ensure this file includes the styles

const ScoreInterpretationTable = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <div onClick={handleShow} className="score-interpretation-text">
        Score Interpretation
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          className="chevron-icon"
        >
          <path
            d="M3.34188 9.5L3.342 9C3.28547 8.99999 3.22661 8.98207 3.17272 8.94314C3.11827 8.90381 3.0703 8.84368 3.04059 8.76616C3.01081 8.68845 3.00253 8.60099 3.01812 8.51626C3.03368 8.43164 3.07131 8.35879 3.12091 8.30515C3.12093 8.30513 3.12094 8.30511 3.12096 8.30509L5.85956 5.34508L6.17373 5.00552L5.85956 4.66596L3.12091 1.7059L3.12096 1.70585L3.11496 1.69958C3.08137 1.66452 3.05262 1.62047 3.03217 1.56901C3.0117 1.51752 3.00048 1.46088 3.00002 1.40269C2.99955 1.34449 3.00986 1.28756 3.02955 1.23552C3.04923 1.18353 3.07739 1.13873 3.1106 1.10284C3.14373 1.06703 3.18095 1.04103 3.21895 1.02422C3.25682 1.00748 3.29586 0.999652 3.33419 1.00001C3.37252 1.00037 3.41155 1.00893 3.44935 1.02648C3.48728 1.04409 3.52429 1.07095 3.55703 1.10758L3.55697 1.10763L3.56285 1.11398L6.88944 4.70951C6.95636 4.78187 7 4.88775 7 5.00552C7 5.12326 6.95639 5.22912 6.88949 5.30148C6.88947 5.3015 6.88945 5.30152 6.88944 5.30154L3.56285 8.89706L3.5628 8.89712C3.49708 8.96818 3.41662 8.99998 3.34177 9L3.34188 9.5ZM3.34188 9.5C3.17742 9.49996 3.01666 9.44722 2.87993 9.34845C2.74319 9.24967 2.63663 9.1093 2.57369 8.94507L3.92986 9.23662C3.77393 9.40521 3.56243 9.49995 3.34188 9.5Z"
            fill="#1C64F2"
            stroke="#1C64F2"
          />
        </svg>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Score Interpretation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table className="score-interpretation-table">
            <thead>
              <tr>
                <th>Score On Test</th>
                <th>Interpreted As</th>
              </tr>
            </thead>
            <tbody>
              <tr className="low-color">
                <td>
                  <span data-tooltip-id="tooltip0-20">0-20</span>
                </td>
                <td data-tooltip-id="tooltip0-20">Poor Performance</td>
              </tr>
              <tr className="med-color">
                <td>
                  <span data-tooltip-id="tooltip20-40">20-40</span>
                </td>
                <td data-tooltip-id="tooltip20-40">Fair Performance</td>
              </tr>
              <tr className="noRisk-color">
                <td>
                  <span data-tooltip-id="tooltip40-60">40-60</span>
                </td>
                <td data-tooltip-id="tooltip40-60">Good Performance</td>
              </tr>
              <tr className="noRisk-color">
                <td>
                  <span data-tooltip-id="tooltip60-80">60-80</span>
                </td>
                <td data-tooltip-id="tooltip60-80">Very Good Performance</td>
              </tr>
              <tr className="high-color">
                <td>
                  <span data-tooltip-id="tooltip80-100">80-100</span>
                </td>
                <td data-tooltip-id="tooltip80-100">Excellent Performance</td>
              </tr>
            </tbody>
          </Table>
          <ReactTooltip id="tooltip0-20" place="top" effect="solid">
            Child is having significant difficulty with this subtest
          </ReactTooltip>
          <ReactTooltip id="tooltip20-40" place="top" effect="solid">
            Child may have a difficulty with this subtest
          </ReactTooltip>
          <ReactTooltip id="tooltip40-60" place="top" effect="solid">
            Child had a good performance in this subtest
          </ReactTooltip>
          <ReactTooltip id="tooltip60-80" place="top" effect="solid">
            Child had a very good performance in this subtest
          </ReactTooltip>
          <ReactTooltip id="tooltip80-100" place="top" effect="solid">
            Child is proficient in this subtest
          </ReactTooltip>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ScoreInterpretationTable;
